import { useEffect, useRef } from "react";

/**
 * Runs `action` when `key` is released anywhere on the page. The listener is added once, but it always calls the
 * latest `action` (a ref), so the state it reads is the current one, not the first render's: e.g. a modal's Esc
 * that mustn't close while saving.
 */
export const useKeyPress = (key: string, action: () => void) => {
  const latest = useRef(action);
  latest.current = action;

  useEffect(() => {
    const onKeyup = (event: KeyboardEvent) => {
      if (event.key === key) {
        latest.current();
      }
    };
    window.addEventListener("keyup", onKeyup);
    return () => window.removeEventListener("keyup", onKeyup);
  }, [key]);
};
